import { IEvaluationCommand } from "@Evaluation/cqrs";


export class DeleteEvalModelCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.EvaluationModels.Commands.DeleteEvalModelCommandV1, TCh.Domain.Evaluation';

	Id: string;
	WorkspaceId: number;

	constructor(workspaceId: number, evalModelId: number)
	{
		this.Id = evalModelId.toString();
		this.WorkspaceId = workspaceId;
	}

	static matchType(cmd: IEvaluationCommand)	{
		return cmd.$type == 'TCh.Domain.Evaluation.EvaluationModels.Commands.DeleteEvalModelCommandV1, TCh.Domain.Evaluation'
	}
}

export class RenameGoalCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.EvaluationModels.Commands.RenameGoalCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	Name: string;

	constructor(workspaceId: number, evalModelId: number, name: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = evalModelId.toString();
		this.Name = name;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.EvaluationModels.Commands.RenameGoalCommandV1, TCh.Domain.Evaluation'
	}
}

export class CreateEvalModelCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.EvaluationModels.Commands.CreateEvalModelCommandV1, TCh.Domain.Evaluation';

	Id: string;
	WorkspaceId: number;
	ProjectId: number;
	GoalName: string;
	CriteriaHierarchyName: string;
        
	constructor(workspaceId: number, projectId: number, goalName: string, criteriaHierarchyName: string)
	{
		this.Id = "0";
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.GoalName = goalName;
		this.CriteriaHierarchyName = criteriaHierarchyName;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.EvaluationModels.Commands.CreateEvalModelCommandV1, TCh.Domain.Evaluation'
	}
}

export class CloneEvalModelCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.EvaluationModels.Commands.CloneEvalModelCommandV1, TCh.Domain.Evaluation';

	Id: string;
	WorkspaceId: number;
	CloneGoalName: string;
	CloneCriteriaHierarchyName: string;

	constructor(workspaceId: number, evalModelId: number, cloneGoalName: string, cloneChName: string)
	{
		this.Id = evalModelId.toString();
		this.WorkspaceId = workspaceId;
		this.CloneGoalName = cloneGoalName;
		this.CloneCriteriaHierarchyName = cloneChName;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.EvaluationModels.Commands.CloneEvalModelCommandV1, TCh.Domain.Evaluation'
	}
}

export class GenerateVotesCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.EvaluationModels.Commands.GenerateVotesCommandV1, TCh.Domain.Evaluation';

	Id: string;
	AccessUrl: string;
	GenerateVotesForAllRespondents: boolean;

	constructor(accessUrl: string, generateVotesForAllRespondents: boolean)
	{
		this.Id = "0";
		this.AccessUrl = accessUrl;
		this.GenerateVotesForAllRespondents = generateVotesForAllRespondents;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.EvaluationModels.Commands.GenerateVotesCommandV1, TCh.Domain.Evaluation'
	}
}
